import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavbarStatus, NavigationItem, NavigationService } from 'src/app/core/navigation.service';
import { UtilsService } from 'src/app/core/utils.service';
import { LOCAL_NAVBAR_STATUS_KEY } from 'src/app/shared/constants/operationals';
import { NavigationItemLabel } from 'src/app/shared/constants/translations';
import { SellerDetailsGeneralComponent } from '../seller-details-general/seller-details-general.component';
import { SellerDetailsEventDataComponent } from '../seller-details-event-data/seller-details-event-data.component';

@Component({
  selector: 'app-seller-details',
  templateUrl: './seller-details.component.html',
  styleUrls: ['./seller-details.component.scss'],
})
export class SellerDetailsComponent {
  @ViewChild(SellerDetailsGeneralComponent) general_component?: SellerDetailsGeneralComponent;
  @ViewChild(SellerDetailsEventDataComponent) event_component?: SellerDetailsEventDataComponent;
  navbar_status: NavbarStatus;
  current_nav_item?: NavigationItem = this.navigation_service.navigation_set.nav_items.get(NavigationItemLabel.sellers);

  seller_id: string | null;

  tabs = this.navigation_service.navigation_set.seller_details_tabs;
  current_tab = this.tabs.get('article');

  constructor(
    private navigation_service: NavigationService,
    private utils_service: UtilsService,
    private route: ActivatedRoute,
  ) {
    this.navbar_status = (localStorage.getItem(LOCAL_NAVBAR_STATUS_KEY) as NavbarStatus) || NavbarStatus.closed;
    this.seller_id = this.route.snapshot.paramMap.get('seller_id');
  }

  ngOnInit(): void {
    this.current_tab = this.tabs.get('article');
  }

  onRefresh(): void {
    if (this.current_tab === this.tabs.get('article')) {
      this.general_component?.onRefresh();
    }

    if (this.current_tab === this.tabs.get('timeline')) {
      this.event_component?.onRefresh();
    }
  }

  onTabChange(current_tab: string): void {
    this.current_tab = current_tab;
  }

  onNavbarStatusChange(navbar_status: NavbarStatus): void {
    this.navbar_status = navbar_status;
    localStorage.setItem(LOCAL_NAVBAR_STATUS_KEY, navbar_status);
  }

  getNavbarClass(): { [key: string]: boolean | undefined } {
    return this.utils_service.getNavbarClass(this.navbar_status);
  }

  getToolbarWidthClass(): string {
    if (this.navbar_status == NavbarStatus.open) {
      return 'sp-toolbar__open-width';
    }
    return 'sp-toolbar__closed-width';
  }
}
